// extracted by mini-css-extract-plugin
export var activePlatformAlertsAlertPreview = "active-platform-alerts__alert-preview_skrVnN6dXsMb7wJZqj_F";
export var activePlatformAlertsFilterBody = "active-platform-alerts__filter-body_iJnaZZsRkybJm10GJcwV";